import { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import { ModalProps } from '@typings';
import { JWT_TOKEN } from '@constants';
import { toast } from '@features';
import { resetContext } from '@slices';
import { useDispatch } from '@hooks';
import { localStorage } from '@utils';

import { Button, Modal } from '@components/Shared';

type Props = ModalProps;

export const SwitchAccountModal: React.FC<Props> = ({ closeModal }) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const { logout } = useAuth0();

  const handleAccountSwitch = async () => {
    try {
      setLoading(true);

      localStorage.clear(JWT_TOKEN);
      dispatch(resetContext());

      logout({
        logoutParams: {
          returnTo: window.location.origin,
        },
      });
    } catch (error) {
      toast.error('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal.Content title="Wrong Account?" className="w-[560px]">
      It looks like organization invitation was sent to a different account than
      the one you&apos;re currently using. Would you like to switch accounts?
      <Modal.Footer>
        <Button variant="ghost" onClick={closeModal}>
          Continue with Current Account
        </Button>
        <Button
          loading={loading}
          variant="error"
          className="px-10 capitalize"
          onClick={handleAccountSwitch}
        >
          Logout
        </Button>
      </Modal.Footer>
    </Modal.Content>
  );
};
